<!-- 手机号注册 -->
<template>
  <div class="res">
    <div class="title">输入手机号</div>
    <div class="item">
      <div class="left">
        <span class="txt">中国(+86)</span>
        <input type="text" maxlength="11" v-model="mobile" placeholder="请输入手机号码" @input='handleInputChange'>
      </div>
      <div class="right icon" v-if="isShowClose" @click="close">
        <img src="@/assets/img/images/close2.png" />
      </div>
    </div>
    <div class="hr"></div>
    <div class="item">
      <div class="left">
        <input type="text" maxlength="6" v-model="code" placeholder="请输入验证码" @input='handleInputChange2'>
      </div>
      <div :class="['right','txt',isShowClose?'txtred':'']" @click="getCode">获取验证码</div>
    </div>
    <div class="hr"></div>
    <div :class="['btn',isShowClose?'btnred':'']" @click="go">立即绑定</div>
    <div class="read" @click="checkChange" v-if="displayType == '1'">
      <img class="radio" :src="checked?'@/assets/img/images/checked.png':'@/assets/img/images/uncheck.png'" />
      <span class="desc">我已阅读并同意<i class="blue">《用户服务协议》</i></span>
    </div>
    <div class="read" @click="checkChange" v-else>
      <img class="radio" :src="checked?'@/assets/img/images/new/checked.png':'@/assets/img/images/uncheck.png'" />
      <span class="desc">我已阅读并同意<i class="blue">《用户服务协议》</i></span>
    </div>
  </div>
</template>

<script>
import * as api from "@/api";
import { mapMutations } from "vuex";
import JmmToast from '@/components/JmmToast'

export default {
  name: "login",
  data() {
    return {
      token: "fjenpjlnjinhejcmcnkhcefeehlcaidf",
      //手机号
      mobile: '',
      //验证码
      code: '',
      //平台
      channel: '',
      // 手机号是否输入
      isShowClose: false,
      // 是否已阅读须知
      checked: false,
      prohibit: true,
      displayType: '1'
    };
  },
  created() {
    this.merchantId = this.$route.query.merchantId;
    if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
      localStorage.setItem('cityMerchantId', this.merchantId);
    }
    this.displayType = localStorage.getItem("displayType");
    if(null == this.displayType || undefined == this.displayType){
      this.displayType = "1";
    }
    this.channel = this.$route.query.channel 
    //判断渠道ID
    if(null == this.channel || undefined == this.channel){
      this.channel = '';
    }
  },
  methods: {
    // 获取实时手机号值
    handleInputChange(e){
      // 刷新数据
      this.mobile = e.currentTarget.value;
      if(this.mobile!=''){
        this.isShowClose = true;
      }else{
        this.isShowClose = false;
      }
    },
    // 获取实时验证码值
    handleInputChange2(e){
      // 刷新数据
      this.code = e.currentTarget.value;
    },
    // 删除手机号
    close(){
      this.mobile = '';
      this.isShowClose = false;
    },
    // 获取验证码按钮
    async getCode(){
      let rgh = /^[1]([3-9])[0-9]{9}$/
      if (!rgh.test(this.mobile)) {
        return JmmToast('手机号码有误')
      }
      //防重点击
      if (!this.prohibit) {
        console.log('正在获取中，请勿重复')
        return
      }
      var i = 61
      let that = this
      let intervalID = setInterval(function() {
        i -= 1
        if (i == -1) {
          that.isShowClose = true
          clearInterval(intervalID)
          return
        }
      }, 1000)
      this.isShowClose = false
      try {
        localStorage.setItem('reToken', this.token)
        const res = await api.user.getMsg(this.mobile)
        if (res.code === '000000') {
         console.log(res.message, 'res')
        }
      } catch (error) {
       console.log(error)
      }
    },
    // 点击阅读须知radiobox
    checkChange(){
      this.checked = !this.checked;
    },
    // 立即绑定按钮
    async go(){
      try {
        let info={
            platform: this.channel,
            mobile: this.mobile,
            code: this.code
        };
        localStorage.setItem("reToken",this.token);
        const { code, data, message } =  await api.user.getmobileLogin(info);
        console.log(code);
        console.log(data);
        if (code == "000000") {
           localStorage.setItem("reSESSIONKEY",data.SESSIONKEY);
           localStorage.setItem("reSIGN",data.sign);
        }
        else {
          console.log(data);
           HyrToast(submsg || msg)
        }
      } catch (err) {
        console.log(err);
      }
    }
  },
};
</script>

<style lang="stylus">
@import '../../assets/css/layout.styl';
@import '../../assets/css/common.styl';
@import '../../assets/css/icon.css';
@import '../../assets/css/stylesheet.css';

.res {
  padding-left: 78px;
  padding-right: 78px;
  width: 100%;
  height: 100%;
  background: #fff;
  overflow-x: hidden;
  box-sizing: border-box;
}
.title{
  padding-top: 138px;
  padding-bottom: 113px;
  font-size: 56px;
  color: #515151;
  font-weight: bold;
  line-height: 56px;
}
.item{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.left{
  font-size: 30px;
  color: #333333;
}
.left .txt{
  font-weight: bold;
}
.left input{
  padding-left: 48px;
}
.left input::-webkit-input-placeholder{
  color: #CCCCCC;
}
.right.icon{
  width: 36px;
  height: 36px;
}
.right.icon img{
  display: inline-block;
  width: 100%;
  height: 100%;
}
.hr{
  margin-top: 48px;
  margin-bottom: 48px;
  width: 100%;
  height: 1px;
  background: #EDEDED;
}
.right{
  font-size: 30px;
  font-weight: bold;
}
.right.txt{
  color: #9D9D9D;
}
.right.txtred{
  color: #FF6666;
}
.btn{
  margin-top: 110px;
  margin-bottom: 23px;
  width: 100%;
  height: 100px;
  line-height: 100px;
  text-align: center;
  background: #CCCCCC;
  border-radius: 50px;
  font-size: 32px;
  color: #FFFFFF;
}
.btnred{
  background: #FF6666;
}
.read{
  display: flex;
  align-items: center;
}
.radio{
  display: inline-block;
  width: 28.5px;
  height: 28.5px;
}
.desc{
  padding-left: 5px;
  font-size: 24px;
  color: #707070;
}
.blue{
  color: #2680EB;
}
</style>



// WEBPACK FOOTER //
// src/view/mobileLogin/index.vue